import { render, staticRenderFns } from "./CustomerRCCR.vue?vue&type=template&id=9b87c922&scoped=true&"
import script from "./CustomerRCCR.vue?vue&type=script&lang=ts&"
export * from "./CustomerRCCR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87c922",
  null
  
)

export default component.exports